export const sketchDefaultData = {
    createDt: null,
    createdBy: null,
    description: '',
    sketchCommands: [
      {
        type: 'default',
        details: [],
      },
      {
        type: 'annotations',
        annotations: [],
      },
      {
        detailList: [],
        detailLayers: [],
        numLayers: 2,
      },
      {
        commandStartX: 100,
        commandStartY: 100,
        originX: null,
        originY: null,
      },
      {
        drawData: {
          lines: [],
        },
        standaloneDrawData: {
          lines: [],
        },
      },
      {
        previewSettings: {
          mode: 'none',
          offset: 10,
        },
      },
    ],
    sketchID: null,
    updateDt: null,
    updatedBy: null,
  };